import { render, staticRenderFns } from "./CreatorProfileMaikaKokubo.vue?vue&type=template&id=12eb9d37&scoped=true&"
import script from "./CreatorProfileMaikaKokubo.vue?vue&type=script&lang=js&"
export * from "./CreatorProfileMaikaKokubo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eb9d37",
  null
  
)

export default component.exports